import { createContext, useContext } from "react";
import { RulesetRegistry } from "../../domain/ruleset-registry";

export const RulesetsContext = createContext<RulesetRegistry | null>(null);

export function useRulesets() {
  const rulesets = useContext(RulesetsContext);
  if (!rulesets) {
    throw new Error("Missing rulesets in React context.");
  }
  return rulesets;
}
